import { render, staticRenderFns } from "./HWUpgrade.vue?vue&type=template&id=a1560aec"
import script from "./HWUpgrade.vue?vue&type=script&lang=js"
export * from "./HWUpgrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports